(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-producto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-product-page')) {
    customElements.define('lp-product-page', class extends HTMLElement {
      connectedCallback() {
        this._ready = () => this.setup();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._ready, { once: true });
        } else {
          this.setup();
        }
      }

      setup() {
        if (!this.isConnected) return;
        this._controller?.abort();
        this._controller = new AbortController();
        const select = this.querySelector('[data-variant]');
        if (!select) return;

        const update = (event) => {
          const option = select.selectedOptions[0];
          if (!option) return;
          const price = this.querySelector('[data-price]');
          const prefix = this.querySelector('[data-price-prefix]');
          const compare = this.querySelector('[data-compare]');
          const button = this.querySelector('[data-add]');
          const label = this.querySelector('[data-add-label]');
          const quantity = this.querySelector('[name="quantity"]');
          const available = option.dataset.available === 'true';
          if (price) price.textContent = option.dataset.price;
          if (prefix) prefix.hidden = true;
          if (compare) {
            compare.textContent = option.dataset.compare || '';
            compare.hidden = !option.dataset.compare;
          }
          if (button) button.disabled = !available;
          if (label) label.textContent = available ? 'Añadir al carrito' : 'Agotado';
          if (quantity) quantity.disabled = !available;
          const image = this.querySelector('.lp__image');
          if (event?.type === 'change' && image && option.dataset.image && !this.hasAttribute('data-custom-image')) {
            if (image.getAttribute('src') !== option.dataset.image) {
              image.removeAttribute('srcset');
              image.src = option.dataset.image;
            }
            image.alt = option.dataset.alt || '';
          }
        };

        select.addEventListener('change', update, { signal: this._controller.signal });
        update();
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this._ready);
        this._controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dela-home-slideshow')) {
  customElements.define('dela-home-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const initialize = () => {
        this.slides = Array.from(this.querySelectorAll('[data-dhs-slide]'));
        if (!this.slides.length) return;
        this.index = 0;
        this.status = this.querySelector('[data-dhs-status]');
        const controls = this.querySelector('[data-dhs-controls]');
        if (controls) controls.hidden = this.slides.length < 2;
        this.querySelector('[data-dhs-prev]')?.addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-dhs-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
        document.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (selected !== -1) this.show(selected);
        }, options);
        this.show(0);
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { ...options, once: true });
      } else {
        initialize();
      }
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
      if (this.status) this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
